import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import SIcon from '@/components/SIcon.vue';
import SRoundedIcon from '@/components/SRoundedIcon/SRoundedIcon.vue';

export type SEmptyStateSize = 'small' | 'medium' | 'large';

interface SEmptyStateProps {
  /**
   * Main title
   */
  title: string;
  /**
   * Description, displayed below the title
   */
  description?: string;
  /**
   * Size of the empty state: small, medium or large
   */
  size?: SEmptyStateSize;
  /**
   * Main icon
   */
  icon?: string;
  /**
   * Primary action button label
   */
  primaryActionLabel?: string,
  /**
   * Primary action button icon
   */
  primaryActionIcon?: string,
  /**
   * Primary action button handler method
   */
  primaryActionHandler?: (() => void) | null;
  /**
   * Secondary action button label
   */
  secondaryActionLabel?: string,
  /**
   * Secondary action button icon
   */
  secondaryActionIcon?: string,
  /**
   * Secondary action button handler method
   */
  secondaryActionHandler?: (() => void) | null;
  /**
   * Learn more link
   */
  learnMoreLink?: string;
  /**
   * Learn more text
   */
  learnMoreText?: string;
}

type SEmptyStateSizeConfiguration = {
  iconSize: 'small' | 'medium' | 'large' | 'x-large' | 'xx-large',
  titleClasses: string,
  descriptionClasses: string,
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SEmptyState',
  props: {
  title: null,
  description: { default: '' },
  size: { default: 'medium' },
  icon: { default: 'icon-building' },
  primaryActionLabel: { default: '' },
  primaryActionIcon: { default: '' },
  primaryActionHandler: { type: Function, default: null },
  secondaryActionLabel: { default: '' },
  secondaryActionIcon: { default: '' },
  secondaryActionHandler: { type: Function, default: null },
  learnMoreLink: { default: '' },
  learnMoreText: { default: '' }
},
  setup(__props) {

const props = __props;


const sizeConfiguration = _computed((): SEmptyStateSizeConfiguration => {
  const availableSizeConfigs: { small: SEmptyStateSizeConfiguration, medium: SEmptyStateSizeConfiguration, large: SEmptyStateSizeConfiguration } = {
    small: {
      iconSize: 'small',
      titleClasses: '',
      descriptionClasses: '',
    },
    medium: {
      iconSize: 'large',
      titleClasses: 'text-h6',
      descriptionClasses: '',
    },
    large: {
      iconSize: 'xx-large',
      titleClasses: 'text-h5',
      descriptionClasses: 'text-h6',
    },
  };
  return availableSizeConfigs[props.size];
});


return { __sfc: true,props, sizeConfiguration, _computed, SIcon, SRoundedIcon }
}

})